export function cssVariableWithOverride(cssVariable, fallback) {
    return `var(${cssVariable}, ${fallback})`;
}
